import React, { useState } from "react";
import { Button, Spin } from "antd";
import { DownOutlined, UpOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { getDateString } from "util/common";
import {
  formatPurchaseAmount,
  formatPurchaseEventType,
  formatPurchaseProductKey,
} from "util/purchaseHistory";
import styles from "./style.module.scss";

const PlanPurchaseHistory = ({ purchases, total, loading, onRefresh, canView }) => {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(false);

  if (!canView) {
    return null;
  }

  return (
    <div className={styles.content}>
      <div className={styles.historyHeader}>
        <div>
          <h3 className={styles.header}>
            {t("settings.plan_purchase_history_title", "Satın alma geçmişi")}
          </h3>
          <p className={styles.historySubtitle}>
            {t(
              "settings.plan_purchase_history_sub",
              "Add-on ve ek satın alımların kaydı (kart bilgisi saklanmaz).",
            )}
          </p>
        </div>
        <Button
          type="text"
          icon={expanded ? <UpOutlined /> : <DownOutlined />}
          onClick={() => setExpanded((v) => !v)}
          aria-expanded={expanded}
        >
          {expanded
            ? t("settings.plan_purchase_history_hide", "Gizle")
            : t("settings.plan_purchase_history_show", "Göster")}
        </Button>
      </div>

      {expanded && (
        <div className={styles.historyBody}>
          <div className={styles.historyToolbar}>
            <span className={styles.historyCount}>
              {t("settings.plan_purchase_history_count", "{{count}} kayıt", {
                count: total,
              })}
            </span>
            <Button size="small" onClick={onRefresh} disabled={loading}>
              {t("settings.plan_purchase_history_refresh", "Yenile")}
            </Button>
          </div>

          {loading && !purchases?.length ? (
            <div className={styles.historyLoading}>
              <Spin size="small" />
            </div>
          ) : !purchases?.length ? (
            <p className={styles.historyEmpty}>
              {t("settings.plan_purchase_history_empty", "Henüz kayıt yok.")}
            </p>
          ) : (
            <div className={styles.historyTableWrap}>
              <table className={styles.historyTable}>
                <thead>
                  <tr>
                    <th>{t("settings.plan_purchase_col_date", "Tarih")}</th>
                    <th>{t("settings.plan_purchase_col_product", "Ürün")}</th>
                    <th>{t("settings.plan_purchase_col_event", "Olay")}</th>
                    <th>{t("settings.plan_purchase_col_amount", "Tutar")}</th>
                  </tr>
                </thead>
                <tbody>
                  {purchases.map((row) => (
                    <tr key={row.id}>
                      <td>
                        {row.created_at
                          ? getDateString(row.created_at)
                          : "—"}
                      </td>
                      <td>{formatPurchaseProductKey(row.product_key, t)}</td>
                      <td>{formatPurchaseEventType(row.event_type, t)}</td>
                      <td>
                        {formatPurchaseAmount(row.amount_cents, row.currency)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default PlanPurchaseHistory;
